import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { FaCheckCircle } from 'react-icons/fa';

const PaiementSuccess = () => {
    const [kycVerified, setKycVerified] = useState(true);
    const initUser = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me?verifyKYC=true`, config)
            .then((res) => {
                const user = res.data;
                if (user.kyc_url) {
                    setKycVerified(false);
                    setTimeout(() => {
                        window.location.href = user.kyc_url;
                    }, 3000);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        initUser();
    }, []);

    return (
        <main className="mt-10 flex items-center justify-center px-4">
            <div className="bg-gray-10 w-full max-w-md rounded-2xl border p-8 text-center shadow-md">
                <FaCheckCircle className="mx-auto mb-4 text-4xl text-green-500" />
                <h1 className="mb-2 text-2xl font-bold text-gray-800">
                    Paiement réussi !
                </h1>
                <p className="mb-5 text-base text-gray-600">
                    Merci pour votre commande.
                </p>
                {kycVerified ? (
                    <a
                        href="/admin/dashboard"
                        className="text-md rounded-lg bg-leadrs px-4 py-2 font-semibold text-white transition-colors hover:bg-green-700"
                    >
                        Voir mes commandes
                    </a>
                ) : (
                    <p className="mtext-sm text-gray-500">
                        Vous allez être redirigé vers la page de vérification
                        KYC dans quelques secondes.
                    </p>
                )}
            </div>
        </main>
    );
};

export default PaiementSuccess;
